import { Link } from 'react-router-dom';
import { RoutePath } from 'src/router';

import { clientPortalDashboardUrl } from 'src/utils/constants';

export default function PermissionDenied() {
  return (
    <div className="pt-6">
      <div className="container px-2">
        <div className="content card px-5 py-5">
          <h2 className="is-size-2">Permission Denied</h2>
          <p>
            You may visit <Link to={RoutePath.root}>the Main Page</Link>
          </p>
          <p>
            Or visit Client Portal Dashboard <a href={clientPortalDashboardUrl}>{clientPortalDashboardUrl}</a> to see
            all available modules
          </p>
        </div>
      </div>
    </div>
  );
}
